
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"101","height":"100","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M32.25 44a6 6 0 10-12 0v20c0 16.568 13.432 30 30 30 16.568 0 30-13.432 30-30V48a6 6 0 10-12 0v-4a6 6 0 10-12 0v-4a6 6 0 10-12 0V12a6 6 0 10-12 0v46-14z","fill":"#fff","fill-opacity":".2","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M76.25 32V4M82.25 10l-6-6-6 6","stroke":"#fff","stroke-width":"4","stroke-miterlimit":"10","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    